/* RESPONSIBLE TEAM: team-ai-agent */
import FinAIAgentTaskRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/tasks/task';

export default FinAIAgentTaskRoute;
